import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

import { SoftCard } from '@/components/ui/soft-card';

/**
 * Divided list of nav cards used on the Store and Account settings
 * landings. Each item: icon, label, detail subtext, link target.
 */
export function SettingsCardList({ items }) {
	return (
		<SoftCard className="!p-0 overflow-hidden">
			<ul className="divide-y divide-border/60">
				{items.map((item) => {
					const Icon = item.icon;
					return (
						<li key={item.label}>
							<Link to={item.to} className="flex items-center gap-4 px-5 py-4 transition hover:bg-muted/60 md:px-6">
								<div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent text-accent-foreground">
									<Icon className="h-5 w-5" />
								</div>
								<div className="min-w-0 flex-1">
									<div className="text-sm font-semibold text-foreground">{item.label}</div>
									<div className="text-xs text-muted-foreground">{item.detail}</div>
								</div>
								<ChevronRight className="h-4 w-4 text-muted-foreground" />
							</Link>
						</li>
					);
				})}
			</ul>
		</SoftCard>
	);
}
